import React from 'react';

const InstructionScreen = ({ timerLimit, children }) => {
  const minutes = Math.ceil(timerLimit / 60);
  return (
    <div className="flex items-center justify-center min-h-screen bg-white px-4 text-center">
      <div className="max-w-md w-full border border-gray-200 shadow-md rounded-xl p-6">
        <h2 className="text-xl font-semibold text-blue-700 mb-3">Start Quiz</h2>
        <p className="text-sm text-gray-600 mb-4">
          Please enter <strong>Fullscreen Mode</strong> by pressing:
        </p>
        <div className='pb-4'>{children}</div>
        <ul className="text-left text-xs text-gray-600 space-y-2 mb-4">
          <li>⏱ {minutes} minute{minutes > 1 ? 's' : ''} per question</li>
          <li>🔒 One attempt per question</li>
          <li>🚫 Switching tabs = auto-cancel</li>
          <li>🛑 DevTools will terminate the quiz</li>
        </ul>

        <p className="text-xs text-gray-400">
          Stay focused & use a stable connection.
        </p>
      </div>
    </div>
  );
};

export default InstructionScreen;